import { h } from 'vue';
import { Empty } from 'ant-design-vue';
import zhTW from 'ant-design-vue/es/locale/zh_TW';

/** 後台 Ant Design Vue 繁中語系 */
export const adminLocale = {
    ...zhTW,
    Empty: {
        ...zhTW.Empty,
        description: '暫無資料'
    },
    Table: {
        ...zhTW.Table,
        emptyText: '暫無資料'
    }
};

const SMALL_EMPTY_COMPONENTS = new Set([
    'Select',
    'TreeSelect',
    'Cascader',
    'Transfer',
    'Mentions'
]);

/** 下拉 Teleport 至 body 時無法繼承 locale，需明確帶入 description */
export function renderAntdEmpty(componentName) {
    const isSmall = SMALL_EMPTY_COMPONENTS.has(componentName);
    return h(Empty, {
        image: Empty.PRESENTED_IMAGE_SIMPLE,
        description: '暫無資料',
        class: isSmall ? 'ant-empty-small' : undefined
    });
}

export default adminLocale;
